import { InjectionToken } from '@angular/core';
import { PaymentsGatewayEnvironmentVariables } from '../types/payment-gateway-environment-variables.type';

export const PAYMENTS_GATEWAY_ENVIRONMENT_VARIABLES = new InjectionToken<Partial<PaymentsGatewayEnvironmentVariables>>(
  'PAYMENT_PROVIDER_ENVIRONMENT_VARIABLES',
);
